import { Box, CircularProgress, Typography } from '@mui/material';

/*
 * Circular progress with the percent inside.
 *   percent = number (0-100)  -> determinate circle with "NN%"
 *   percent = null/undefined  -> normal spinning circle (size of the file not known yet)
 */
const DownloadProgress = ({ percent, size = 34 }) => {
  const known = typeof percent === 'number';

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', verticalAlign: 'middle' }}>
      <CircularProgress
        variant={known ? 'determinate' : 'indeterminate'}
        value={known ? percent : undefined}
        size={size}
        color="secondary"
      />

      {known && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            sx={{ fontSize: size * 0.27, fontWeight: 700, lineHeight: 1 }}
          >
            {percent}%
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default DownloadProgress;